module.exports = __webpack_public_path__ + "img/LINK.4b02bc11.svg";